module.exports = __webpack_public_path__ + "static/media/005-man-1.d4e22641.svg";